module.exports = __webpack_public_path__ + "img/ar_my_set_color.cf6e8bc2.svg";